import isNil from 'lodash/isNil';
import merge from 'lodash/merge';

import { http } from '@/apis/social-listening';

const generateFilters = ({ hashtags, startDate, endDate, ...rest }) => ({
  hashtags,
  source_created: { on_or_after: startDate, on_or_before: endDate },
  ...rest,
});

export async function getIgHashtagsSearchResults(
  { hashtags, startDate, endDate, sorts, paging },
  config = {},
) {
  return http.post(
    '/hashtags/instagram/posts/search',
    { filters: generateFilters({ hashtags, startDate, endDate }), sorts, paging },
    config,
  );
}

export async function getIgHashtagsRelatedTagsResults(
  { hashtags, startDate, endDate, limit },
  config = {},
) {
  const requestConfig = isNil(limit) ? config : merge({ params: { limit } }, config);
  return http.post(
    '/hashtags/instagram/related_tags',
    { filters: generateFilters({ hashtags, startDate, endDate }) },
    requestConfig,
  );
}

export async function postIgHashtagsPostsCSV(
  { csvType, socketId, hashtags, startDate, endDate, sorts },
  config = {},
) {
  return http.post(
    '/hashtags/instagram/posts/csv',
    { csvType, socketId, filters: generateFilters({ hashtags, startDate, endDate }), sorts },
    config,
  );
}

export async function getIgHashtagsPostVolume({ hashtags, startDate, endDate, rule }, config = {}) {
  return http.post(
    '/hashtags/instagram/post_volume',
    { filters: generateFilters({ hashtags, startDate, endDate, rule }) },
    config,
  );
}

export async function getIgHashtagsTimeSeriesPostVolume(
  { hashtags, startDate, endDate, scale },
  config = {},
) {
  return http.post(
    '/hashtags/instagram/time_series/post_volume',
    { filters: generateFilters({ hashtags, startDate, endDate, scale }) },
    config,
  );
}
